var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnablePushNotifications3X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 606,
    height: 531,
    viewBox: "0 0 606 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enable Push Notifications"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.281 358.102L383.523 365.044L210.002 321.119L211.758 314.177C225.642 317.691 236.411 304.318 238.153 297.447L248.166 257.884C256.095 229.091 282.314 209.169 312.181 209.242C314.738 199.692 324.556 194.027 334.104 196.587C343.654 199.147 349.322 208.962 346.76 218.512C372.953 233.132 386.378 263.267 379.725 292.515L370.028 330.83C367.97 338.95 378.341 356.345 385.281 358.102Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.575 342.572C267.241 360.288 282.951 373.301 300.667 371.637C310.316 370.732 319.045 365.529 324.435 357.471L265.575 342.572Z",
    fill: "#53B1FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.38 290.872C547.38 422.241 440.882 528.74 309.513 528.74C178.143 528.74 71.647 422.241 71.647 290.872C71.647 159.502 178.143 53.0039 309.513 53.0039C440.882 53.0039 547.38 159.502 547.38 290.872Z",
    stroke: "#D0D5DD",
    strokeDasharray: "5.02 5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.154 290.871C486.154 388.427 407.068 467.513 309.512 467.513C211.954 467.513 132.873 388.427 132.873 290.871C132.873 193.315 211.954 114.229 309.512 114.229C407.068 114.229 486.154 193.315 486.154 290.871Z",
    stroke: "#D0D5DD",
    strokeDasharray: "5.05 5.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M476.86 128.07C480.289 128.07 483.062 130.84 483.062 134.271C483.062 137.702 480.289 140.473 476.86 140.473C473.43 140.473 470.656 137.702 470.656 134.271C470.656 130.84 473.43 128.07 476.86 128.07ZM495.461 128.07C498.892 128.07 501.663 130.84 501.663 134.271C501.663 137.702 498.892 140.473 495.461 140.473C492.03 140.473 489.26 137.702 489.26 134.271C489.26 130.84 492.03 128.07 495.461 128.07ZM514.069 128.07C517.5 128.07 520.27 130.84 520.27 134.271C520.27 137.702 517.5 140.473 514.069 140.473C510.638 140.473 507.867 137.702 507.867 134.271C507.867 130.84 510.638 128.07 514.069 128.07ZM469.92 168.383H499.516C502.308 168.383 502.308 168.404 503.644 169.392C504.982 170.38 520.255 180.787 520.255 180.787V168.383H520.97C529.147 168.383 535.757 162.221 535.757 154.545V114.058C535.757 106.383 529.131 100.161 520.97 100.161H469.92C461.761 100.161 455.133 106.383 455.133 114.058V154.545C455.133 162.221 461.761 168.383 469.92 168.383Z",
    fill: "#1570EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.693 199.531C111.693 201.775 109.883 203.586 107.637 203.586C105.395 203.586 103.585 201.775 103.585 199.531C103.585 197.288 105.395 195.475 107.637 195.475C109.883 195.475 111.693 197.288 111.693 199.531ZM99.5248 199.531C99.5248 201.775 97.712 203.585 95.4706 203.585C93.2269 203.585 91.4141 201.775 91.4141 199.531C91.4141 197.287 93.2269 195.475 95.4706 195.475C97.712 195.475 99.5248 197.287 99.5248 199.531ZM87.363 199.531C87.363 201.775 85.5501 203.586 83.3064 203.586C81.065 203.586 79.2522 201.775 79.2522 199.531C79.2522 197.288 81.065 195.475 83.3064 195.475C85.5501 195.475 87.363 197.288 87.363 199.531ZM121.846 212.787V186.314C121.846 181.295 117.51 177.227 112.177 177.227H78.7963C73.4609 177.227 69.1271 181.295 69.1271 186.314V212.787C69.1271 217.804 73.4494 221.833 78.7963 221.833H79.2661V229.946C79.2661 229.946 89.2515 223.139 90.1247 222.493C91.0002 221.847 91.0002 221.833 92.8245 221.833H112.177C117.51 221.833 121.846 217.804 121.846 212.787Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.588 342.612C267.254 360.328 282.964 373.341 300.68 371.677C310.329 370.772 319.058 365.569 324.449 357.511L265.588 342.612Z",
    fill: "#53B1FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.495 236.171C409.535 241.032 412.57 246.757 414.632 252.826C416.734 258.897 417.761 265.346 417.866 271.8C417.866 275.029 417.635 278.254 417.217 281.451C416.667 284.632 416.033 287.79 415.033 290.85C413.101 296.971 410.182 302.776 406.203 307.717C406.031 307.931 405.724 307.963 405.511 307.793C405.346 307.658 405.291 307.438 405.355 307.245C407.427 301.348 409.143 295.532 410.296 289.63C410.509 288.141 410.803 286.674 411.05 285.2C411.22 283.713 411.444 282.237 411.573 280.752C411.669 279.264 411.861 277.786 411.923 276.299C411.946 274.809 412.017 273.322 412.01 271.834C412.045 265.878 411.38 259.931 410.223 254.027C409.033 248.119 407.243 242.3 405.094 236.403C405.05 236.281 405.112 236.146 405.234 236.103C405.33 236.066 405.433 236.098 405.495 236.171Z",
    fill: "#53B1FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.252 238.236C432.153 242.73 435.091 248.061 437.137 253.719C439.189 259.384 440.373 265.403 440.584 271.458C440.813 277.51 440.075 283.595 438.457 289.391C436.842 295.185 434.323 300.722 430.771 305.494C430.748 305.523 430.704 305.53 430.677 305.51C430.654 305.491 430.645 305.461 430.652 305.436C432.123 299.693 433.356 294.106 434.103 288.488C434.85 282.873 435.095 277.261 434.887 271.669C434.658 266.079 433.982 260.507 432.792 254.977C431.607 249.44 429.932 243.977 428.023 238.368C428 238.297 428.037 238.222 428.108 238.197C428.16 238.178 428.218 238.194 428.252 238.236Z",
    fill: "#53B1FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.243 266.915C219.005 260.752 218.992 254.314 219.973 248.021C220.921 241.712 222.961 235.56 225.794 229.815C228.695 224.104 232.403 218.789 236.882 214.242C241.328 209.679 246.484 205.813 252.173 203.113C252.276 203.065 252.395 203.108 252.443 203.209C252.482 203.292 252.461 203.388 252.395 203.447C247.768 207.648 243.507 212.028 239.742 216.77C236.004 221.521 232.697 226.57 230.025 231.944C227.279 237.284 225.184 242.942 223.591 248.78C222.024 254.631 221.057 260.67 220.44 266.906C220.433 266.958 220.385 267 220.33 266.995C220.287 266.99 220.252 266.956 220.243 266.915Z",
    fill: "#53B1FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.816 254.732C199.645 248.946 199.625 242.916 200.475 237.012C201.353 231.108 203.106 225.308 205.693 219.906C208.253 214.495 211.558 209.432 215.535 204.998C219.492 200.556 224.067 196.674 229.164 193.74C225.002 197.884 221.179 202.206 217.845 206.854C214.522 211.506 211.632 216.413 209.289 221.574C206.97 226.742 205.109 232.11 203.782 237.649C202.418 243.186 201.6 248.868 201.011 254.723C201.004 254.776 200.959 254.815 200.901 254.81C200.86 254.806 200.823 254.774 200.816 254.732Z",
    fill: "#53B1FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.294 358.142C385.294 358.142 375.031 354.154 369.636 348.464C362.123 340.541 362.618 331.896 367.697 315.212C373.672 295.344 373.509 274.415 371.208 264.821C363.194 231.393 346.773 218.552 346.773 218.552C372.966 233.171 386.392 263.306 379.738 292.555L370.042 330.869C368.341 336.53 378.354 356.384 385.294 358.142L383.536 365.084L385.294 358.142Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 25",
    d: "M26.7087 322.898L22.2924 322.763",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 27",
    d: "M23.5396 314.524L20.3723 317.483",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    d: "M15.2866 310.701L15.2201 315.019",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 31",
    d: "M6.77783 313.664L9.85345 316.813",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 33",
    d: "M3 321.684L7.41404 321.819",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 35",
    d: "M6.16919 330.057L9.33878 327.098",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 37",
    d: "M14.4232 333.881L14.4897 329.563",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 39",
    d: "M22.933 330.916L19.8574 327.767",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 41",
    d: "M602.649 261.34L600.708 263.441",
    stroke: "#D0D5DD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 43",
    d: "M593.537 263.166L595.002 264.516",
    stroke: "#D0D5DD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 45",
    d: "M592.06 272.479L594.001 270.377",
    stroke: "#D0D5DD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 47",
    d: "M601.168 270.653L599.706 269.303",
    stroke: "#D0D5DD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 49",
    d: "M424.856 14.3372L420.16 14.2112",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 51",
    d: "M412.707 3L412.636 7.01298",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 53",
    d: "M399.637 13.2081L404.333 13.3319",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 55",
    d: "M411.785 24.5442L411.856 20.5312",
    stroke: "#53B1FD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 57",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1088 447.628C73.7306 448.638 68.1042 453.602 66.1791 459.488C65.8559 454.019 62.3838 447.146 58.5634 446.156C63.2249 444.508 68.2738 438.451 69.6168 433.347C69.3739 438.696 74.2302 446.463 77.1088 447.628Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 59",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.228 35.831C153.622 36.2917 149.004 39.5002 147.061 43.7172C147.292 39.6171 145.301 34.197 142.541 33.129C146.156 32.3039 150.441 28.2291 151.883 24.5438C151.239 28.5087 154.184 34.7149 156.228 35.831Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 61",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.606 65.6058C498.124 65.5301 495.365 62.6493 495.443 59.1703C495.519 55.6913 498.399 52.932 501.876 53.0076C505.357 53.0833 508.117 55.9641 508.041 59.443C507.963 62.922 505.085 65.6814 501.606 65.6058Z",
    fill: "#D1D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 63",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.622 478.482C498.595 478.418 496.193 475.908 496.257 472.881C496.321 469.851 498.831 467.449 501.86 467.513C504.89 467.58 507.292 470.087 507.226 473.117C507.159 476.144 504.652 478.548 501.622 478.482Z",
    fill: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 65",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1372 149.225C44.2625 149.184 42.7751 147.633 42.8164 145.756C42.8554 143.881 44.4092 142.396 46.2839 142.435C48.1586 142.476 49.646 144.028 49.607 145.902C49.5658 147.779 48.0119 149.267 46.1372 149.225Z",
    stroke: "#D0D5DD",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "messages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval 9",
    filter: "url(#filter0_d_3606_71054)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 376.574,
    cy: 355.5,
    rx: 22.5736,
    ry: 22.5001,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: 0,
    d: "M377.095 368.675C374.896 368.667 373.004 368.125 371.419 367.052C369.842 365.978 368.628 364.422 367.775 362.385C366.932 360.348 366.514 357.898 366.523 355.035C366.523 352.179 366.944 349.746 367.788 347.735C368.641 345.723 369.855 344.194 371.432 343.145C373.017 342.088 374.905 341.56 377.095 341.56C379.285 341.56 381.169 342.088 382.746 343.145C384.331 344.202 385.55 345.736 386.402 347.748C387.254 349.75 387.676 352.179 387.668 355.035C387.668 357.907 387.241 360.361 386.389 362.398C385.545 364.435 384.335 365.99 382.758 367.064C381.182 368.138 379.294 368.675 377.095 368.675ZM377.095 364.086C378.595 364.086 379.793 363.331 380.687 361.823C381.582 360.314 382.025 358.052 382.017 355.035C382.017 353.049 381.812 351.395 381.403 350.074C381.003 348.753 380.432 347.76 379.69 347.096C378.957 346.431 378.092 346.098 377.095 346.098C375.604 346.098 374.41 346.844 373.516 348.336C372.621 349.827 372.169 352.06 372.16 355.035C372.16 357.046 372.361 358.725 372.761 360.071C373.17 361.41 373.746 362.415 374.487 363.088C375.229 363.753 376.098 364.086 377.095 364.086Z",
    fill: "url(#paint0_linear_3606_71054)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3606_71054",
    x: 328.966,
    y: 321.027,
    width: 95.2157,
    height: 95.0684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.35378
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.17237
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.596235 0 0 0 0 1 0 0 0 0.331012 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3606_71054"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3606_71054",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3606_71054",
    x1: 377.1,
    y1: 302.1,
    x2: 333.9,
    y2: 323.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnablePushNotifications3X);
export default __webpack_public_path__ + "static/media/EnablePushNotifications@3x.266bfcdb84551d88916b708546870dc9.svg";
export { ForwardRef as ReactComponent };